import React from 'react'

const CustomButton = ({btnType, styles,handleClick,title}) => {
  return (
    <button 
      type={btnType}
      className={` font-semibold text-[1em] leading-[2em] text-black min-h-[52px] px-4 ${styles}`}
      onClick={handleClick}
    >
    {title}
    </button>
  )
}

export default CustomButton
